/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientDetails2 } from './ClientDetails2';
import {
    ClientDetails2FromJSON,
    ClientDetails2FromJSONTyped,
    ClientDetails2ToJSON,
} from './ClientDetails2';

/**
 * 
 * @export
 * @interface IntermediaryToDoListViewModel
 */
export interface IntermediaryToDoListViewModel {
    /**
     * 
     * @type {Array<ClientDetails2>}
     * @memberof IntermediaryToDoListViewModel
     */
    clients: Array<ClientDetails2>;
}

/**
 * Check if a given object implements the IntermediaryToDoListViewModel interface.
 */
export function instanceOfIntermediaryToDoListViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clients" in value;

    return isInstance;
}

export function IntermediaryToDoListViewModelFromJSON(json: any): IntermediaryToDoListViewModel {
    return IntermediaryToDoListViewModelFromJSONTyped(json, false);
}

export function IntermediaryToDoListViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryToDoListViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clients': ((json['Clients'] as Array<any>).map(ClientDetails2FromJSON)),
    };
}

export function IntermediaryToDoListViewModelToJSON(value?: IntermediaryToDoListViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Clients': ((value.clients as Array<any>).map(ClientDetails2ToJSON)),
    };
}

